
import '../scss/styles.scss'

import 'babel-polyfill'

import './src/common'
import './src/cookies'
import './src/agreement-form'
